import React, { useState, useEffect } from "react";
import AuctionSvgBlog from "app/Icons/AuctionSvgBlog";
import InvestmentSvgBlog from "app/Icons/InvestmentSvgBlog";
import NewsSvgBlog from "app/Icons/NewsSvgBlog";
import ResearchSvgBlog from "app/Icons/ResearchSvgBlog";
import ArticleSvgBlog from "app/Icons/ArticleSvgBlog";
import FaqSvgBlog from "app/Icons/FaqSvgBlog";
import HomeSvgBlog from "app/Icons/HomeSvgBlog";
import FavSvgBlog from "app/Icons/FavSvgBlog";
import RecentSvgBlog from "app/Icons/RecentSvgBlog";
import { useRouter } from "next/router";
import BlogSearchComponent from "./BlogSearchComponent";
interface BlogSidebarInterface {
  id: Number;
  name: string;
  icon: any;
  catName: any;
}

const BlogSidebar = (props: any) => {
  const router = useRouter();
  const category = router.query?.cat;
  const [activeSidebarMenuItem, setActiveSidebarMenuItem] = useState<Number>(0);

  const menuItems: any = [];
  props.allCategories.forEach((category: any) => {
    if (category.attributes?.name == "faq") {
      menuItems.push({
        id: category.id,
        value:
          category.attributes?.name.charAt(0).toLocaleUpperCase() +
          category.attributes?.name.slice(1),
        catName: category.attributes.name,
        slug: category.attributes.slug,
        icon: (
          <img
            src={category.attributes?.categoryIcon?.data?.attributes?.url}
            alt="Category Icon"
          />
        ),
      });
    } else {
      menuItems.unshift({
        id: category.id,
        value:
          category.attributes?.name.charAt(0).toLocaleUpperCase() +
          category.attributes?.name.slice(1),
        catName: category.attributes.name,
        slug: category.attributes.slug,
        icon: (
          <img
            src={category.attributes?.categoryIcon?.data?.attributes?.url}
            alt="Category Icon"
          />
        ),
      });
    }
  });
  menuItems.unshift({
    id: 0,
    value: "All categories",
    catName: "all",
    slug: "all",
    icon: <HomeSvgBlog activeSidebarMenuItem={activeSidebarMenuItem} />,
  });

  const activeMenu = menuItems.filter((item: any) => category == item.slug);

  useEffect(() => {
    if (activeMenu.length > 0) {
      setActiveSidebarMenuItem(activeMenu[0].id);
      setTimeout(() => {
        props.setLoading(false);
      }, 2000);
    }
  }, [category, activeMenu]);
  return (
    <>
      <div
        id="separator-sidebar"
        className=" h-fit w-full flex-col sm:justify-center lg:justify-start transition-transform translate-x-0 bg-white"
        aria-label="Sidebar"
      >
        <BlogSearchComponent allPostsBySearch={props.allPostsBySearch} />
        <div className="px-3 overflow-y-auto h-fit bg-gray-50 dark:bg-gray-800 bg-white w-full">
          <ul className="space-y-2 md:mx-auto font-medium w-fit lg:w-full sm:justify-center lg:justify-start">
            <div className="flex sm:p-1 lg:p-0 sm:justify-center lg:justify-start items-center font-medium text-lg w-full">
              Blog Categories
            </div>
            {menuItems.map((item: any, index: any) => {
              return (
                <li
                  key={index}
                  onClick={async () => {
                    await router.push(`/blogs?cat=${item.slug}`);
                    setActiveSidebarMenuItem(item.id);
                    props.setBlogByCat(item.slug);
                    props.setLoading(false);
                  }}
                  className="cursor-pointer hover:bg-gray-100"
                >
                  <div
                    className={`${
                      item.id == activeSidebarMenuItem
                        ? "svg-blue-class"
                        : "svg-dark-class"
                    } flex items-center p-1 rounded-lg`}
                  >
                    {item.icon}
                    <span className="flex-1 ml-3 whitespace-nowrap">
                      {item.value}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default BlogSidebar;
